import { AbstractModel } from './AbstractModel'

export class ShopDonateOrder extends AbstractModel {
    shopDonateId: number|null = null
    companyName: string|null = null
    name: string|null = null
    paypalEmail: string|null = null
    price: number|null = null
    customerId: number|null = null
    teamId: number|null = null
    statePayment: boolean|null = null
    note: string|null = null
    message = ''
    dateCreate: string|null = null

    get donatorName () {
      if (!this.note) {
        return ''
      }
      const splittedNote = this.note.split(';')
      if (splittedNote.length <= 1) { // there is no ; in it
        return this.note
      }
      if (this.note.length <= 2) { // there is only one ; in it
        return splittedNote[0]
      }
      return `${splittedNote[0]} ${splittedNote[1]}`
    }

    get donatorFirstName () {
      if (!this.note) {
        return ''
      }
      const splittedNote = this.note.split(';')
      if (splittedNote.length <= 1) { // there is no ; in it
        return this.note
      }
      if (this.note.length <= 2) { // there is only one ; in it
        return splittedNote[0]
      }
      return `${splittedNote[0]}`
    }
}
